angular.module('onboarding.broker.carriers',
	[
		'naif.base64'
	]);
